import React from 'react';
import { $_ } from '../i18n';
import RevealEmailButton from '../components/RevealEmailButton';

const privacyEmailCharCodes: number[] = [
  112, 114, 105, 118, 97, 99, 121, 64, 109, 97, 105, 108, 46, 116, 117, 98, 108, 121, 46, 97, 112, 112
];

const PrivacyPage: React.FC = () => {
  const privacyCopyButtonLabel = $_('page.shared.revealEmail.privacyButton');
  const privacyCopyAriaLabel = $_('page.shared.revealEmail.privacyAriaLabel');

  return (
    <div className="container mx-auto px-4 py-16 md:py-32 md:px-10 lg:px-32 xl:max-w-6xl">
      <article className="prose dark:prose-invert xs:prose-sm sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl prose-headings:text-gray-900 prose-p:text-gray-700">
        <h1>{$_('page.privacyPolicy.title')}</h1>

        {/* Introduction */}
        <p>{$_('page.privacyPolicy.introduction')}</p>

        {/* 1. Information We Collect */}
        <h2>{$_('page.privacyPolicy.infoCollection.title')}</h2>
        <p>{$_('page.privacyPolicy.infoCollection.description')}</p>

        {/* 2. Data Storage and Security */}
        <h2>{$_('page.privacyPolicy.dataStorage.title')}</h2>
        <p>{$_('page.privacyPolicy.dataStorage.description')}</p>

        {/* 3. Data Sharing and Disclosure */}
        <h2>{$_('page.privacyPolicy.dataSharing.title')}</h2>
        <p>{$_('page.privacyPolicy.dataSharing.description')}</p>

        {/* 4. Billing Data */}
        <h2>{$_('page.privacyPolicy.billing.title')}</h2>
        <p>{$_('page.privacyPolicy.billing.description')}</p>

        {/* 5. Data Retention */}
        <h2>{$_('page.privacyPolicy.dataRetention.title')}</h2>
        <p>{$_('page.privacyPolicy.dataRetention.description')}</p>

        {/* 6. Your Choices and Data Deletion */}
        <h2>{$_('page.privacyPolicy.userRights.title')}</h2>
        <p>{$_('page.privacyPolicy.userRights.description')}</p>

        {/* 7. Cookies and Tracking */}
        <h2>{$_('page.privacyPolicy.cookies.title')}</h2>
        <p>{$_('page.privacyPolicy.cookies.description')}</p>

        {/* 8. Children's Privacy */}
        <h2>{$_('page.privacyPolicy.childrenPrivacy.title')}</h2>
        <p>{$_('page.privacyPolicy.childrenPrivacy.description')}</p>

        {/* 9. International Data Transfers */}
        <h2>{$_('page.privacyPolicy.internationalTransfers.title')}</h2>
        <p>{$_('page.privacyPolicy.internationalTransfers.description')}</p>

        {/* 10. Changes to the Privacy Policy */}
        <h2>{$_('page.privacyPolicy.policyChanges.title')}</h2>
        <p>{$_('page.privacyPolicy.policyChanges.description')}</p>

        {/* 11. Contact Information */}
        <h2>{$_('page.privacyPolicy.contactInfo.title')}</h2>
        <p>{$_('page.privacyPolicy.contactInfo.description')}</p>
        <RevealEmailButton
          emailCharCodes={privacyEmailCharCodes}
          buttonLabel={privacyCopyButtonLabel}
          ariaLabel={privacyCopyAriaLabel}
        />

        {/* 12. Governing Law and Jurisdiction */}
        <h2>{$_('page.privacyPolicy.governingLaw.title')}</h2>
        <p>{$_('page.privacyPolicy.governingLaw.description')}</p>

        {/* 13. Compliance with Laws and Google/YouTube Policies */}
        <h2>{$_('page.privacyPolicy.complianceWithLaws.title')}</h2>
        <p>{$_('page.privacyPolicy.complianceWithLaws.description')}</p>

        {/* 14. Data & Permissions (Appendix) */}
        <h2>{$_('page.privacyPolicy.dataUseStrip.title')}</h2>
        <p>{$_('page.privacyPolicy.dataUseStrip.intro')}</p>

        <h3>{$_('page.privacyPolicy.dataUseStrip.identity.title')}</h3>
        <p>{$_('page.privacyPolicy.dataUseStrip.identity.desc')}</p>

        <h3>{$_('page.privacyPolicy.dataUseStrip.tabs.title')}</h3>
        <p>{$_('page.privacyPolicy.dataUseStrip.tabs.desc')}</p>

        <h3>{$_('page.privacyPolicy.dataUseStrip.storage.title')}</h3>
        <p>{$_('page.privacyPolicy.dataUseStrip.storage.desc')}</p>

        <h3>{$_('page.privacyPolicy.dataUseStrip.hosts.title')}</h3>
        <p>{$_('page.privacyPolicy.dataUseStrip.hosts.desc')}</p>

        <h3>{$_('page.privacyPolicy.dataUseStrip.limitedUse.title')}</h3>
        <p>{$_('page.privacyPolicy.dataUseStrip.limitedUse.desc')}</p>

        <h3>{$_('page.privacyPolicy.dataUseStrip.revoke.title')}</h3>
        <p>{$_('page.privacyPolicy.dataUseStrip.revoke.desc')}</p>
      </article>
    </div>
  );
};

export default PrivacyPage;
